var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27 17",
    width: 27,
    height: 17,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 224") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: none;stroke: #000000;stroke-miterlimit:100;stroke-width: 2.4 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line 54",
    fillRule: "evenodd",
    className: "s0",
    d: "m24.9 2.6h-22.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 55",
    fillRule: "evenodd",
    className: "s0",
    d: "m24.9 9h-14.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 56",
    fillRule: "evenodd",
    className: "s0",
    d: "m24.9 14.6h-7.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.18be34524d769e7240512ea128dad8f8.svg";
export { ForwardRef as ReactComponent };